var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-dialog-container',{attrs:{"title-dialog":_vm.$t('project.blank-title'),"btn-icon":"mdi-plus","btn-text":_vm.$t('project.new'),"is-valid-disabled":!_vm.isValid},on:{"ok-pushed":_vm.createNewProject}},[_c('form-new-project',{on:{"nameUpdated":_vm.nameUpdated,"sizeUpdated":_vm.sizeUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }